<template>
  <div>
    <ol>
      <li v-for="(option, index) in getAllOptions" :key="index">
        <button
            class="option-normal"
            @click.prevent="optionChanged(option.option)"
            :class="[option.option === getSelected ? 'option-selected' : '']"
        >
          <span class="image"><img :src=" require(`../assets/icons/${option.src}`) " /></span>
          <span class="option">{{ option.option }}</span>
        </button>
      </li>
    </ol>
  </div>
</template>

<script>

export default {
  name: 'QuizSingleSelect',

  props: {
    options: {
      required: true,
    },
  },

  data() {
    return {
      selected: - 1,
    }
  },

  computed: {
    getAllOptions() {
      return this.options;
    },
    getSelected() {
      return this.selected;
    }
  },

  methods: {
    optionChanged( option ) {
      this.selected = option;
      this.$emit( 'optChanged', this.selected );
    }
  }
}
</script>
